/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Background from 'material/embeds/embed/shared/background/background_container';
import PartnerLogo from 'material/embeds/embed/shared/logo/partner/partner_container';
import Question from 'material/embeds/embed/shared/question/question_container';
import AnswerSet from 'material/embeds/embed/shared/answerset/answerset_container';
import AddAnswer from 'material/embeds/embed/edit/addanswer/addanswer_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/content/poll/poll_styles';



/* ========== ~~~~~~~~~~ POLL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Poll extends Component {
    render() {
        return(
            <div className={`uniquecontent poll ${this.props.classes.poll}`}>
                <div className={`structure header`}>
                    <div className={`structureinner`}>
                        <PartnerLogo />
                    </div>
                </div>
                <div className={`structure body`}>
                    <div className={`structureinner`}>
                        <Question contentId={this.props.contentId} isEditable={this.props.isEditable} />
                        <AnswerSet contentId={this.props.contentId} isEditable={this.props.isEditable} />
                    </div>
                </div>
                <Background contentId={this.props.contentId} isEditable={this.props.isEditable} />
                <AddAnswer contentId={this.props.contentId} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Poll);